import { htlcErrorsBySelector } from "./abi";
import { JsonRpcError } from "./rpc";
export function decodeContractError(error) {
    if (error instanceof JsonRpcError && typeof error.data === 'string' && error.data.startsWith('0x')) {
        const selector = error.data.slice(0, 10);
        return htlcErrorsBySelector[selector] ?? null;
    }
    return null;
}
export const hex = (v) => v;
